import { PRODUCT_OPTIONS_URL, GET_TAX_URL, STORE_CHECKOUT, STORE_VALIDATE } from '@/modules/cart/endpoints'
import ApiErrorFactory from '@/entities/errors/api_errors/ApiErrorsFactory'
import AxiosFactory from '@/entities/security/AxiosFactory'

export default class CartApi {
  async getProductOptions(slug: string) {
    try {
      const response = await AxiosFactory.createAxiosInstanceWithoutToken().get(`${PRODUCT_OPTIONS_URL}${slug}`)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async getTax(country: string) {
    try {
      const response = await AxiosFactory.createAxiosInstanceWithoutToken().get(`${GET_TAX_URL}${country}`)
      return response.data.vat
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
  async postCheckout(req: { type: string; cart: Record<string, unknown> }) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(`${STORE_CHECKOUT}${req.type}`, req.cart)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }

  async validateCart(cart: Record<string, unknown>) {
    try {
      const response = await AxiosFactory.createAxiosInstance().post(`${STORE_VALIDATE}`, cart)
      return response.data
    } catch (e) {
      throw ApiErrorFactory.create(e)
    }
  }
}
